import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    allVersions: {
        id: 'iaso.workflows.allVersions',
        defaultMessage: 'All versions',
    },
    actions: {
        id: 'iaso.label.actions',
        defaultMessage: 'Action(s)',
    },
    version: {
        id: 'iaso.label.version',
        defaultMessage: 'Version',
    },
    targetVersion: {
        id: 'iaso.workflows.targetVersion',
        defaultMessage: 'Target version',
    },
    sourceVersion: {
        id: 'iaso.workflows.sourceVersion',
        defaultMessage: 'Source version',
    },
    see: {
        defaultMessage: 'See',
        id: 'iaso.label.see',
    },
    status: {
        defaultMessage: 'Status',
        id: 'iaso.forms.status',
    },
    workflow: {
        id: 'iaso.label.workflow',
        defaultMessage: 'Workflow',
    },
    workflowVersion: {
        id: 'iaso.label.workflowVersion',
        defaultMessage: 'Workflow version',
    },
    workflows: {
        id: 'iaso.label.workflows',
        defaultMessage: 'Workflows',
    },
    name: {
        defaultMessage: 'Name',
        id: 'iaso.label.name',
    },
    search: {
        defaultMessage: 'Search',
        id: 'iaso.search',
    },
    draft: {
        defaultMessage: 'Draft',
        id: 'iaso.label.draft',
    },
    unpublished: {
        defaultMessage: 'Unpublished',
        id: 'iaso.label.unpublished',
    },
    published: {
        defaultMessage: 'Published',
        id: 'iaso.label.published',
    },
    infos: {
        defaultMessage: 'Informations',
        id: 'iaso.instance.infos',
    },
    type: {
        defaultMessage: 'Type',
        id: 'iaso.entities.type',
    },
    referenceForm: {
        id: 'iaso.orgUnits.referenceForm',
        defaultMessage: 'Reference form',
    },
    followUps: {
        id: 'iaso.workflows.followUps',
        defaultMessage: 'Follow ups',
    },
    changes: {
        id: 'iaso.workflows.changes',
        defaultMessage: 'Changes',
    },
    form: {
        id: 'iaso.instance.formShort',
        defaultMessage: 'Form',
    },
    updated_at: {
        id: 'iaso.forms.updated_at',
        defaultMessage: 'Updated',
    },
    created_at: {
        id: 'iaso.forms.created_at',
        defaultMessage: 'Created',
    },
    results: {
        id: 'iaso.label.resultsLower',
        defaultMessage: 'result(s)',
    },
    forms: {
        defaultMessage: 'Forms',
        id: 'iaso.forms.title',
    },
    condition: {
        defaultMessage: 'Condition',
        id: 'iaso.workflows.condition',
    },
    noCondition: {
        defaultMessage: 'Always true',
        id: 'iaso.workflows.noCondition',
    },
    mapping: {
        defaultMessage: 'Mapping',
        id: 'iaso.workflows.mapping',
    },
    addWorkflowVersion: {
        defaultMessage: 'Add workflow version',
        id: 'iaso.workflows.addWorkflowVersion',
    },
    confirm: {
        defaultMessage: 'Confirm',
        id: 'iaso.label.confirm',
    },
    cancel: {
        defaultMessage: 'Cancel',
        id: 'iaso.label.cancel',
    },
    add: {
        id: 'iaso.label.add',
        defaultMessage: 'Add',
    },
    copy: {
        id: 'iaso.workflows.copy',
        defaultMessage: 'Copy version',
    },
    edit: {
        id: 'iaso.label.edit',
        defaultMessage: 'Edit',
    },
    delete: {
        id: 'iaso.label.delete',
        defaultMessage: 'Delete',
    },
    deleteTitle: {
        id: 'iaso.workflows.dialog.deleteTitle',
        defaultMessage:
            'Are you sure you want to delete this workflow version?',
    },
    deleteFollowUp: {
        id: 'iaso.workflows.dialog.deleteFollowUp',
        defaultMessage: 'Are you sure you want to delete this follow up?',
    },
    deleteText: {
        id: 'iaso.label.deleteText',
        defaultMessage: 'This operation cannot be undone.',
    },
    save: {
        id: 'iaso.label.save',
        defaultMessage: 'Save',
    },
    publish: {
        id: 'iaso.workflows.publish',
        defaultMessage: 'Publish',
    },
    unpublish: {
        id: 'iaso.workflows.unpublish',
        defaultMessage: 'Unpublish',
    },
    editFollowUp: {
        id: 'iaso.workflows.editFollowUp',
        defaultMessage: 'Edit follow up',
    },
    createFollowUp: {
        id: 'iaso.workflows.createFollowUp',
        defaultMessage: 'Create follow up',
    },
    publishVersion: {
        id: 'iaso.workflows.publishVersion',
        defaultMessage: 'Publish version',
    },
    saveOrder: {
        id: 'iaso.workflows.saveOrder',
        defaultMessage: 'Save order',
    },
    resetOrder: {
        id: 'iaso.workflows.resetOrder',
        defaultMessage: 'Reset order',
    },
    editChange: {
        id: 'iaso.workflows.editChange',
        defaultMessage: 'Edit change',
    },
    createChange: {
        id: 'iaso.workflows.createChange',
        defaultMessage: 'Create change',
    },
    deleteChange: {
        id: 'iaso.workflows.dialog.deleteChange',
        defaultMessage: 'Are you sure you want to delete this change?',
    },
    changeDeleted: {
        id: 'iaso.workflows.dialog.changeDeleted',
        defaultMessage: 'Change deleted successfully',
    },
    target: {
        id: 'iaso.workflows.target',
        defaultMessage: 'Target',
    },
    source: {
        id: 'iaso.workflows.source',
        defaultMessage: 'Source',
    },
    sourceForm: {
        id: 'iaso.workflows.sourceForm',
        defaultMessage: 'Source form',
    },
    targetForm: {
        id: 'iaso.workflows.targetForm',
        defaultMessage: 'Target form',
    },
    changesInfo: {
        id: 'iaso.workflows.changesInfo',
        defaultMessage: 'Source and target should be of the same type',
    },
    changesInfo2: {
        id: 'iaso.workflows.changesInfo2',
        defaultMessage:
            'You cannot have multiple mappings on the same source or target',
    },
    order: {
        id: 'iaso.workflows.order',
        defaultMessage: 'Order',
    },
    latest: {
        id: 'iaso.workflows.latest',
        defaultMessage: 'latest',
    },
    queryTab: {
        id: 'blsq.queryBuilder.queryTab',
        defaultMessage: 'Query',
    },
    jsonTab: {
        id: 'blsq.queryBuilder.jsonTab',
        defaultMessage: 'Json',
    },
    currentDate: {
        id: 'iaso.workflows.queryBuilder.currentDate',
        defaultMessage: 'Current date - constant',
    },
    currentDateTime: {
        id: 'iaso.workflows.queryBuilder.currentDateTime',
        defaultMessage: 'Current date time - constant',
    },
});

export default MESSAGES;
